import React from "react";

function StudentCard(props) {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6 mb-4 mx-auto">

      <div className="card h-100 shadow-lg border-0 student-card text-center">
        <div className="card-body">
          {/* Avatar */}
          <img
            src={`https://api.dicebear.com/6.x/avataaars/svg?seed=${props.name}`}
            alt="avatar"
            className="rounded-circle mb-3 border border-3 border-white student-avatar"
          />
          
          {/* Name */}
          <h5 className="fw-bold">{props.name}</h5>
          <span className="badge bg-gradient mb-3 px-3 py-2">
            🎓 Roll: {props.rollNo}
          </span>

          {/* Info List */}
          <ul className="list-unstyled text-start ps-3 small">
            <li><i className="bi bi-journal-code me-2 text-primary"></i><strong>Course:</strong> {props.course}</li>
            <li><i className="bi bi-clock me-2 text-success"></i><strong>Batch:</strong> {props.batch}</li>
          </ul>

          {/* Action Button */}
          <a href="#" className="btn btn-outline-light btn-sm mt-2 px-3">View Profile</a>
        </div>
      </div>
    </div>
  );
}

export default StudentCard;
